module.exports = __webpack_public_path__ + "img/ic_plus_hover.185c5813.svg";